export type IPadWithZero = (val: any, length: number, begining?: boolean) => string;

export function padWithZero(val: any, length: number, begining?: boolean): string {
  const _thisString = String(val);
  let currentLength = _thisString.length;
  let newString = _thisString;
  if (currentLength < length) {
    while (currentLength < length) {
      if (begining) {
        newString = `0${newString}`;
      } else {
        newString += '0';
      }
      currentLength = newString.length;
    }
  }
  return newString;
}
